"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1271],{

/***/ 78564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const productService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/paginate", {
            params
        }),
    getAllShopProducts: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/products"), {
            params
        }),
    getById: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/search", {
            params
        }),
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/ids", {
            params
        }),
    getViewed: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/product-histories/paginate", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (productService);


/***/ })

}]);